export const typography = {
  fontFamily: {
    primary: 'Avenir, sans-serif'
  },
  
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 800
  },
  
  fontSize: {
    xs: '11px',
    sm: '12px',
    base: '14px',
    lg: '16px'
  },
  
  lineHeight: {
    tight: 1.4
  },
  
  letterSpacing: {
    wide: '1px'
  }
} as const

export type Typography = typeof typography